import { Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';
import { CampaignDiscountGroup } from '../components';

interface CampaignDiscountSectionProps {
  className?: string;
}

// SID-4418(29CM): 캠페인 & 할인 정보 카드 하단 패딩 = 링크 py-3(12) + 섹션 pb-12(12) = 24px.
export const CampaignDiscountSection = ({ className }: CampaignDiscountSectionProps) => (
  <div className={twMerge('w-full bg-white px-4 pb-[12px]!', className)}>
    <div className="pb-1 pt-3">
      <Typography variant="title18pxMed">캠페인 & 할인 상품 정보</Typography>
    </div>
    <CampaignDiscountGroup />
  </div>
);
